<script setup lang="ts">
import { onKeyStroke } from '@vueuse/core'
import PagePreview from '@/modules/preview/components/PagePreview.vue'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

const fromId = parseInt((route.params.id || '1') as string)

function generateArray(fromId: number, length: number) {
  const array = []
  for (let i = 0; i < length; i++) {
    array.push(fromId + i)
  }
  return array
}

onKeyStroke('PageUp', (e) => {
  e.preventDefault()
  console.debug('PageUp', route.params.id)

  let id = fromId - 10
  router.push({ name: 'preview', params: { id: id > 0 ? id : 1 } })
})

onKeyStroke('PageDown', (e) => {
  e.preventDefault()
  console.debug('PageDown', route.params.id)
  let id = fromId + 10
  router.push({ name: 'preview', params: { id: id < 61 ? id : 61 } })
})
</script>

<template>
  <main class="main">
    <template v-for="n in generateArray(fromId, fromId < 61 ? 10 : 9)">
      <PagePreview :page="n" />
    </template>
  </main>
</template>

<style scoped></style>
